import { z } from "zod";
import { common } from "../common";

export const stepGetBaseSchema = z.object({
  type: z.string(),
  step_id: common.objectId,
  api_id: common.uuid.nullable(), // null: 693 (0.01%)
  workflow_id: common.objectId,
  app_group_id: common.objectId,
  workflow_step_name: z.string().nullable(),
  column: z.int().min(0).nullable(),
  row: z.int().min(0).nullable(),
  created: common.dateTime.nullable(), // null: 3_291 (0.05%)
  is_draft: z.boolean(),
  is_head_step: z.boolean(),
  next: z.array(common.objectId),
});
